import { ComparisonValue } from './criteria';
import { EntityFields } from './entity';
import { ReadRequest, Request, WriteRequest } from './request';
import { DataResponse, Response, WriteResponse } from './response';

export enum WorkflowActionType {
  Triggering = 1,
  Branching = 2,
  UpdateField = 3,
}

export enum WorkflowActionOperationType {
  StartWorkflow = 1,
  SetDateToSpecifiedDate = 2,
  SetDateToPlusDays = 3,
  SetDateToPlusWeeks = 4,
  SetDateToPlusMonths = 5,
  SetDateToPlusYears = 6,
  SetDateToCurrentDate = 7,
}

export interface WorkflowActionOperation {
  Type: WorkflowActionOperationType;
  Data: string;
  FieldName?: string | null;
}

export enum WorkflowActionFields {
  Key = EntityFields.Key,
  ParentWorkflowKey = 'ParentWorkflowKey',
  Action = 'Action',
  Conditions = 'Conditions',
  Operations = 'Operations',
}

export interface WorkflowAction {
  [WorkflowActionFields.Key]: string | null;
  [WorkflowActionFields.ParentWorkflowKey]?: string;
  [WorkflowActionFields.Action]?: WorkflowActionType;
  [WorkflowActionFields.Conditions]?: { [field: string]: ComparisonValue };
  [WorkflowActionFields.Operations]?: WorkflowActionOperation[];
}

export interface WorkflowActionReadRequest extends Request {
  WorkflowAction: ReadRequest<WorkflowAction>;
}

export interface WorkflowActionReadResponse extends Response {
  WorkflowAction: DataResponse<WorkflowAction>;
}

export interface WorkflowActionWriteRequest extends Request {
  WorkflowAction: WriteRequest<WorkflowAction>;
}

export interface WorkflowActionWriteResponse extends Response {
  WorkflowAction: WriteResponse<WorkflowAction>;
}
